import { Navigate, useLocation } from 'react-router-dom'
import type { ReactElement } from 'react'
import { useAuthStore } from '@core/auth/auth.store'

export const RequireAuth = ({ children }: { children: ReactElement }) => {
  const { isAuthenticated, isLoading } = useAuthStore()
  const location = useLocation()

  if (isLoading) return <div>Checking authentication...</div>
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />

  return children
}
